import * as Yup from "yup";

export const formValidationPrivilage = Yup.object().shape({
    module_id: Yup.string().required("Module is required !"),
    menu_id: Yup.string().required("Menu is required !"),
    feature_id: Yup.string().required("Feature is required !")
});
